import moment from 'moment'
export const EMPTY_STRING = ''

export const noop = () => {}

export const formatDate = (dateString, dateFormat = 'MM/DD/YYYY') => dateString ? moment.utc(dateString).format(dateFormat) : EMPTY_STRING

export const isNullOrUndefined = o => o === undefined || o === null

export const isNullOrUndefinedOrWhitespace = s => isNullOrUndefined(s) || s === EMPTY_STRING || s.trim() === EMPTY_STRING

export const isAFailedHttpResponse = (res) => {
  return (res === undefined || !/2[0-9][0-9]/.test(res.status || (res.response && res.response.status)))
}

export const maxDate = (date1, date2) => {
  if (isNullOrUndefined(date1) && isNullOrUndefined(date2)) return null
  if (isNullOrUndefined(date1)) return moment(date2)
  if (isNullOrUndefined(date2)) return moment(date1)

  return moment.max(moment(date1), moment(date2))
}

export const diffDates = (date1, date2, unitOfTime = 'days') => {
  return moment(date1).startOf('day').diff(moment(date2).startOf('day'), unitOfTime)
}

export const getDaysUntilDeadline = (deadline) => {
  if (!deadline) return null

  const deadlineDate = new Date(deadline).setHours(0, 0, 0, 0)
  const todayDate = new Date().setHours(0, 0, 0, 0)

  return Math.floor((deadlineDate - todayDate) / (1000 * 60 * 60 * 24))
}
